export default "__VITE_ASSET__ba1ee9ad__"